import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ToastMessageComponent } from 'src/app/shared/components/dialogs/toast-message/toast-message.component';
import { ToastType } from '../enums/ToastType.enum';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private toastedSource: Subject<any> = new Subject<any>();
  toasted$ = this.toastedSource.asObservable();
  private readonly durationMs = 5000;

  constructor(private toastMessage: MatSnackBar) { }

  success(message: string) {
    this.openToast(ToastType.SUCCESS, message);
  }

  error(payload: any) {
    this.openToast(ToastType.ERROR, this.getErrorMessage(payload));
  }

  warning(title: string, message: string) {
    const warningMessage = title ? `${title}: ${message}` : message;
    this.openToast(ToastType.WARNING, warningMessage);
  }

  invalidSession(err: any) {
    console.warn('error: ', err);
    this.error(
      {
        message: 'Your session is no longer valid. Try the following steps to restore your session',
        response: [
          'Refresh your browser',
          'Log out and log back in'
        ]
      }
    );
  }

  toast(payload: any) {
    const type = payload?.type || ToastType.INFO;
    const message = this.getToastMessage(payload);
    this.openToast(type, message);
  }

  private openToast(type: string, message: string) {
    this.toastMessage.openFromComponent(ToastMessageComponent, {
      duration: this.durationMs,
      data: {
        type,
        message
      },
    });
  }

  private getErrorMessage(payload: any): string {
    if (typeof payload === 'string') {
      return payload;
    }

    if (payload?.message) {
      return payload.message;
    }

    const response = payload?.response;
    if (Array.isArray(response) && response.length > 0) {
      return response[0];
    }

    if (typeof response === 'string') {
      return response;
    }

    return 'Something went wrong';
  }

  private getToastMessage(payload: any): string {
    if (typeof payload === 'string') {
      return payload;
    }

    return payload?.message || this.getErrorMessage(payload);
  }

}
